<div #editor></div>
<div class="error" *ngIf="error == true">
  Une erreur est survenue lors du chargement de l'éditeur de texte.
</div>